import { render } from "./page-tata-kelola.vue?vue&type=template&id=60c30d2a&scoped=true"
import script from "./page-tata-kelola.vue?vue&type=script&lang=js"
export * from "./page-tata-kelola.vue?vue&type=script&lang=js"

import "./page-tata-kelola.vue?vue&type=style&index=0&id=60c30d2a&scoped=true&lang=css"

import exportComponent from "D:\\project\\BahteraAdhiguna\\deployment\\ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60c30d2a"]])

export default __exports__